import React, { useState } from 'react';
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

/**
 *实现一个不超过7天范围的日期选择器（天数可以设定）
 1：选定开始时间后，结束时间只能选7天内，其余日期置灰
 2：选定结束时间后，开始时间只能选7天内，其余日期置灰
 3：选择框有值时，打开下拉面板，面板所有日期都可选，
 选定开始时间后，如果当前的结束时间是在不在7天范围内，则清空结束时间让用户重新选择结束日期，只能选7天内，其余日期置灰。
 选定结束时间后，如果当前的开始时间是在不在7天范围内，则清空开始时间让用户重新选择结束日期，只能选7天内，其余日期置灰。
 4：遇到有开始或者结束时间不能更改的话，则打开面板时设置日期[开始日期，开始日期+7]可选或者[结束日期-7，结束日期]可选，其余时间置灰


 规则：spanTime要大于0
      置灰的时间不能为空
*/

function BoundedRangePicker({
  spanTime = 0,
  onChange = () => {},
  value,
  disabledDate = (current) => false,
  ...resProps
}) {
  const { disabled = [] } = resProps;
  const [dates, setDates] = useState([]);
  const [hackValue, setHackValue] = useState();

  const _disabledDate = (current) => {
    if (!disabledDate(current)) {
      if (!spanTime) return false;
      if (!dates || dates.length === 0) {
        return false;
      }
      const tooLate = dates[0] && current.diff(dates[0], 'day') >= spanTime;
      const tooEarly = dates[1] && dates[1].diff(current, 'day') >= spanTime;
      return tooEarly || tooLate;
    } else {
      return true;
    }
  };

  const onOpenChange = (open) => {
    if (open) {
      setHackValue(value);
      setDates(() => {
        let a = [];
        if (disabled[0]) a[0] = value[0];
        if (disabled[1]) a[1] = value[1];
        return a;
      });
    } else {
      setHackValue(undefined);
    }
  };
  return (
    <RangePicker
      value={hackValue || value}
      disabledDate={_disabledDate}
      onCalendarChange={(val, string, info) => {
        if (!val || !spanTime) {
          setDates(val);
          setHackValue(val);
          return;
        }
        if (info.range == 'start' && val[1] && val[1].diff(val[0], 'day') >= spanTime) {
          setDates([val[0], null]);
          setHackValue([val[0], null]);
        } else if (info.range == 'end' && val[0] && val[1].diff(val[0], 'day') >= spanTime[0]) {
          setDates([null, val[1]]);
          setHackValue([null, val[1]]);
        } else {
          setDates(val);
          setHackValue(val);
        }
      }}
      onChange={(_, val) => {
        // 符合条件的日期才能同步出去
        if (spanTime > 0 && _ && _[1].diff(_[0], 'days') >= spanTime) return;
        onChange(_, val);
      }}
      onOpenChange={onOpenChange}
      {...resProps}
    />
  );
}

export default BoundedRangePicker;
